import { GraduationCap, Presentation, Zap, Repeat } from "lucide-react";
import { FORMATS } from "@/lib/campus";

const ICONS = { course: GraduationCap, class: Presentation, lecture: Zap, series: Repeat };

export const TemplatePicker = ({ value, onPick }) => (
  <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-4" data-testid="template-picker">
    {FORMATS.map((f, i) => {
      const Icon = ICONS[f.value];
      const active = value === f.value;
      return (
        <button key={f.value} type="button" data-testid={`template-${f.value}`} onClick={() => onPick(f)}
          style={{ animationDelay: `${i * 70}ms` }}
          className={`text-left rounded-2xl p-5 border transition-[transform,border-color,background-color] duration-200 hover:-translate-y-1 animate-in fade-in slide-in-from-bottom-2 ${
            active ? "border-amber-500 bg-amber-500/10" : "border-white/10 bg-[#121721] hover:border-amber-500/50"}`}>
          <Icon className={`h-7 w-7 mb-4 ${active ? "text-amber-400" : "text-slate-400"}`} />
          <div className="font-bold text-white">{f.label}</div>
          <div className="text-xs text-amber-300/80 mt-0.5">{f.time}</div>
          <p className="text-xs text-slate-400 mt-2">{f.blurb}</p>
        </button>
      );
    })}
  </div>
);
